module.exports = __webpack_public_path__ + "static/image/history/pc/202208.ver2_0_2.jpg?6bbe35a2";